<template>
	<div class="w-full">
		<OriginStandar :index="index"></OriginStandar>
		<vs-row vs-justify="center">
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="6" vs-sm="12" class="text-left">
				<vs-select autocomplete class="mt-5 w-full px-0" v-model="questionsByPage[index].query.type"  :label="$t('MODULE.originDataBase.typeQuery')">
				    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in queries" />
				</vs-select> 
			</vs-col>
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="6" vs-sm="12" class="text-left">
				<vs-select autocomplete class="mt-5 w-full pl-3"  :label="$t('MODULE.originDataBase.typeAction')" v-model="questionsByPage[index].query.action">
				    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in actions" />
				</vs-select> 
			</vs-col>
		</vs-row>

		<vs-row class="mt-5" vs-justify="center">
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12" vs-sm="12" class="text-left">
				<vs-textarea :label="$t('MODULE.originDataBase.query')" v-model="questionsByPage[index].query.q" />
			</vs-col>
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12" vs-sm="12" class="text-left">
				<vs-input class="w-full" :label="$t('MODULE.originDataBase.messagge')" :placeholder="$t('MODULE.originDataBase.messagge')" v-model="questionsByPage[index].query.message"/>				
			</vs-col>
		</vs-row>
	</div>
	
</template>

<script type="text/javascript">
	import OriginStandar from './OrigenStandar.vue';
	import { mapState, mapMutations } from 'vuex';
	export default {
		props: ['index'],
		components: { OriginStandar },
		data() {
			return {
				queries: [
					{
						value: 'sql',
						text: 'Sql'
					},
					{
						value: 'fql',
						text: 'Fql'
					}
				],
				actions: [
					{
						value: 'none',
						text: 'None'
					},
					{
						value: 'start',
						text: 'Start'
					},
					{
						value: 'trigger',
						text: 'Trigger'
					},
					{
						value: 'disabled',
						text: 'Disabled'
					}
				]
			}
		},
		computed: {
			...mapState('resource',['questionsByPage']),
		}
	}
</script>